export var editAboutMe = {
    "startIndex": 0,
    "noOfRowsToFetch": 0,
    "mapOfAdditinalParams": null,
    "createdBy": null,
    "createdOn": 1478304228000,
    "lastUpdatedBy": "ANONYMOUS",
    "lastUpdatedOn": 1478304325000,
    "expiryOn": null,
    "createdOnDateForDisplay": "11/05/2016",
    "createdOnDateInDDMmYYYFormat": null,
    "formattedCreatedDateForDisplay": null,
    "formattedUpdatedDateForDisplay": null,
    "invitationAction": null,
    "ratingAction": null,
    "userDetailsId": 42,
    "firstName": "Fast",
    "middleName": null,
    "lastName": "SSD",
    "emailId": "fastssd27@uvsity.com",
    "gender": "M",
    "phoneMobile": null,
    "phoneWork": null,
    "phoneHome": null,
    "userType": "Professor Emeritus",
    "userBaseType": "Professor",
    "isEduInsUserDefined": true,
    "educationalInstitution": "Alabama Scientific Research Institute",
    "campus": "Alabama South City",
    "userEducationDegreeCourse": "M.Tech, Phd",
    "userEducationYear": null,
    "userEducationSemester": null,
    "userEducationCourseStatus": null,
    "userEducationSubject": "Semiconductors and Embedded Systems",
    "userEducationSpecialization": null,
    "aboutMe": null,
    "myInterests": null,
    "professorConnectionCount": null,
    "studentConnectionCount": null,
    "alumniConnectionCount": null,
    "noOfRatingStars": null,
    "profilePicName": null,
    "privacySettingsTO": {
        "startIndex": 0,
        "noOfRowsToFetch": 0,
        "mapOfAdditinalParams": null,
        "createdBy": "ANONYMOUS",
        "createdOn": 1478304324000,
        "lastUpdatedBy": null,
        "lastUpdatedOn": null,
        "expiryOn": null,
        "createdOnDateForDisplay": "11/05/2016",
        "createdOnDateInDDMmYYYFormat": null,
        "formattedCreatedDateForDisplay": null,
        "formattedUpdatedDateForDisplay": null,
        "privacySettingsId": 20,
        "profileVisibility": "EVERYONE",
        "showProfileVisitors": "ENABLED",
        "emailNotifications": "ENABLED"
    },
    "webTO": {
        "userDetailsId": 42,
        "firstName": "Fast",
        "middleName": null,
        "lastName": "SSD",
        "emailId": "fastssd27@uvsity.com",
        "gender": "M",
        "phoneMobile": null,
        "phoneWork": null,
        "phoneHome": null,
        "userType": "Professor Emeritus",
        "userBaseType": "Professor",
        "isEduInsUserDefined": true,
        "educationalInstitution": "Alabama Scientific Research Institute",
        "campus": "Alabama South City",
        "userEducationDegreeCourse": "M.Tech, Phd",
        "userEducationYear": null,
        "userEducationSemester": null,
        "userEducationCourseStatus": null,
        "userEducationSubject": "Semiconductors and Embedded Systems",
        "userEducationSpecialization": null,
        "professorConnectionCount": null,
        "studentConnectionCount": null,
        "alumniConnectionCount": null,
        "noOfRatingStars": null,
        "profilePicName": null
    }
};
//# sourceMappingURL=editAboutMe.js.map